export default __webpack_public_path__ + "static/media/magic_set.942a7916.riv";